import form from "./form";

const {
	formField: { emails },
} = form;

const initialValues = {
	[emails.name]: "",
};

export default initialValues;
